import React from 'react';

import VariationLoader from './components/variation-loader/VariationLoader';
import ScoresSection from './components/scores-section/ScoresSection';
import ConsiderSection from './components/consider-section/ConsiderSection';

import scss from './VariationScore.module.scss';

function VariationScore() {
  return (
    <div className={scss.wrapper}>
      <ScoresSection />
      <ConsiderSection />

      <VariationLoader />
    </div>
  );
}

export default VariationScore;
